'use client'

import { RequestWithdrawalSheet } from './RequestWithdrawalSheet'
import { useWithdrawalAction } from './useWithdrawalAction'
import { WithdrawalRequestedInfo } from './WithdrawalRequestedInfo'

interface Props {
  assignedProductId: string
  withdrawalRequestedAt?: string | null
  withdrawalRequestInformation?: string | null
  showWithdrawalAction: boolean
  venueName?: string | null
  venueEmail?: string | null
}

export function WithdrawalActionMobile({
  assignedProductId,
  withdrawalRequestedAt,
  withdrawalRequestInformation,
  showWithdrawalAction,
  venueName,
  venueEmail,
}: Props) {
  const { submittedRequestedAt, isLoading, isError, handleConfirm } = useWithdrawalAction({ assignedProductId })

  const resolvedRequestedAt = submittedRequestedAt ?? withdrawalRequestedAt ?? null

  return (
    <>
      <div className="sm:hidden">
        {resolvedRequestedAt && <WithdrawalRequestedInfo venueName={venueName} venueEmail={venueEmail} />}
        {!resolvedRequestedAt && showWithdrawalAction && (
          <RequestWithdrawalSheet
            onConfirm={handleConfirm}
            isLoading={isLoading}
            isError={isError}
            withdrawalRequestInformation={withdrawalRequestInformation}
          />
        )}
      </div>
    </>
  )
}
